// Custom events definitions

// Scroll hit top/bottom boundaries
;(() => {
    CNS.$events.customScrollsEvent = new Event('custom-scrolls')

    CNS.$fns.initAllCustomScrolls = function() {
        const containers = document.querySelectorAll('.js-custom-scroll-event-emitter')
        containers.forEach(internal_initCustomScroll)
    }

    CNS.$fns.initSpecificCustomScrolls = function(selector, containerIdOverride = null) {

        const container = document.querySelector(selector)

        if (container) {
            if (containerIdOverride) {
                container.setAttribute('data-scroll-container-id', containerIdOverride) 
            }
            internal_initCustomScroll(container)
        }
    }

    function internal_initCustomScroll(container) {
        if (!container) { return }

        let canDetectScroll = false
        let hasDown = false
        let hasTop = false
        let lastScroll = 0
        
        const detectScroll = e => {
            if (!canDetectScroll) { return }

            const containerId = 
                container.getAttribute('data-scroll-container-id') 
                || container.dataset.scrollContainerId 
                || 'container ID not specified'

            CNS.$events.customScrollsEvent.containerId = containerId 

            const scrollTop = container.scrollTop
            const scrollableHeight = container.offsetHeight
            const contentHeight = CNS.$fns.getChildrenHeight(container)

            const scrollDown = lastScroll < scrollTop
            lastScroll = scrollTop

            if (scrollTop <= 10 && !hasTop && !scrollDown) {
                hasTop = true
                CNS.$events.customScrollsEvent.side = 'top'
                window.dispatchEvent(CNS.$events.customScrollsEvent)
            } else if (scrollTop > 10 && hasTop && scrollDown) {
                hasTop = false
            }

            if (scrollTop + scrollableHeight + 10 > contentHeight && !hasDown && scrollDown) {
                hasDown = true
                CNS.$events.customScrollsEvent.side = 'bottom'
                window.dispatchEvent(CNS.$events.customScrollsEvent)
            } else if (scrollTop + scrollableHeight - 10 < contentHeight && hasDown && !scrollDown) {
                hasDown = false
            }            
        }

        setTimeout(() => {
            canDetectScroll = true
            container.addEventListener('scroll', detectScroll)
        }, 100)
    }
})();

// should close custom select
;(() => {
    window.addEventListener('click', e => {
        const selects = document.querySelectorAll('.custom-select_opened')
        
        const clickedSelect = Array.from(selects).filter(select => CNS.$fns.isSameOrChild(select, e.target))[0]
        
        selects.forEach(select => {
            const closeCustomSelectEvent = new Event('close-custom-select')
            closeCustomSelectEvent.selectEl = select
            closeCustomSelectEvent.selectId = select.dataset.id

            if (select !== clickedSelect) {    
                closeCustomSelectEvent.shouldClose = true
                window.dispatchEvent(closeCustomSelectEvent)
            } else {
                const zonesString = select.dataset.preventCloseZones
                let shouldClose = true

                if (zonesString) {
                    const zones = zonesString.split(",").map(zone => zone.trim())

                    if (zones.includes('search')) {
                        select.querySelectorAll('.input').forEach(input => {
                            if (input === e.target) {
                                shouldClose = false
                                return
                            }
                        })
                    }
        
                    if (shouldClose) {
                        if (zones.includes('options')) {
                            select.querySelectorAll('.custom-select__options .custom-option').forEach(option => {
                                if (option === e.target) {
                                    shouldClose = false
                                    return
                                }
                            })
                        }
                    }

                    closeCustomSelectEvent.shouldClose = shouldClose
                    window.dispatchEvent(closeCustomSelectEvent)
                } else {
                    closeCustomSelectEvent.shouldClose = true
                    window.dispatchEvent(closeCustomSelectEvent)
                }
            }
        }) 
    })
})();

// Custom events initializations
;(() => {
    CNS.$fns.initAllCustomScrolls()
})();